import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '../../../shared/base-components/base-grid-ui.component';
import { DisplayNote } from '../../models/DisplayNote';
import { GListItem } from '../../models/GListItem';
import { SearchTypeFieldBus } from '../../models/SearchTypeFieldBus';

@Component({
    selector: 'generic-list',
    templateUrl: './generic-list.component.html',
    styleUrls: ['./generic-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GenericListComponent {
    constructor(private globals: GlobalsService)
    {
    }
    data: GListItem[];
    cols: SearchTypeFieldBus[];
    getHidden(par: SearchTypeFieldBus): Boolean {
        return par.hidden;
    }
    getWidth(par: SearchTypeFieldBus): number {
        return par.width; 
    }
}
